import Vid1 from './Components/images/testimonial/3 Watch Wearing Rules Men Shoukd Know.mp4'
import Vid2 from './Components/images/testimonial/2019 Customer Testimonial Video.mp4'
import Vid3 from './Components/images/testimonial/Consumer Testimonial - Dove - Molly Burke.mp4'

export default[
  {
text:"It feels comfortable and doesn't squize you that much it gives you this vibe. i really...",
vid:Vid1
  },
  {
text:"i am looking at it all day now. my friends are now in pain to get it...",
vid:Vid2
  },
  {
text:"i am comfortable with the watch. it makesmy look more appealing and confidance and also ...",
vid:Vid3
  },
]